
		<base-modal
			[title]="title"
			[btnOkClass]="'btn-warning'"
			[btnOkLabel]="'Запустить'"
			[isLoading]="isLoading"
			(onOk)="ok()"
		>
			<div class="alert alert-info" role="alert">
				Выберите действие для восстановления виджетов
			</div>

			<form [formGroup]="form">
				<div class="form-group">
					<div class="form-check">
						<label class="form-check-label">
							<input class="form-check-input" type="radio"
								   formControlName="action"
								   value="check">
							Проверить
						</label>
					</div>

					<div class="form-check">
						<label class="form-check-label">
							<input class="form-check-input" type="radio"
								   formControlName="action"
								   value="fix">
							Исправить
						</label>
					</div>
				</div>
			</form>

			<div class="alert" [ngClass]="resultClass" role="alert" *ngIf="resultMessage" style="margin-top: 15px;">
				<pre style="white-space: pre-wrap; margin-bottom: 0;">{{ resultMessage }}</pre>
			</div>
		</base-modal>
	